import {
  ADMIN_GROUP_GET_ALL_DATA,
  ADMIN_GROUP_GET_BY_ID_DATA,
  ADMIN_GROUP_ADD_DATA,
  ADMIN_GROUP_UPDATE_DATA,
  ADMIN_GROUP_DELETE_DATA,
  ADMIN_GROUP_GET_DATA,
  ADMIN_GROUP_UPDATE_FLAG_DATA,
} from "./Constants";

const initialState = {
  loading: false,
  error: null,
  adminGroup: {},
  adminGroups: [],
  groupDetails: [],
  updateSuccess: false,
  adminGroupAll: [],
  updateFlagSuccess: false,
};

const Reducer = (state = initialState, action) => {
  switch (action.type) {
   
    // Get All
    case ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_LOAD:
      return { 
        ...state, 
        loading: true, 
        adminGroups: [], 
        error: null 
      };
    case ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        adminGroups: action.adminGroups, 
        error: null 
      };
    case ADMIN_GROUP_GET_ALL_DATA.ADMIN_GROUP_GET_ALL_FAIL:
      return { 
        ...state, 
        loading: false, 
        adminGroups: [], 
        error: action.error 
      };

    // Get By ID
    case ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_LOAD:
      return { 
        ...state, 
        loading: true, 
        groupDetails: {}, 
        error: null 
      };
    case ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        groupDetails: action.groupDetails, 
        error: null 
      };
    case ADMIN_GROUP_GET_BY_ID_DATA.ADMIN_GROUP_GET_BY_ID_FAIL:
      return { 
        ...state, 
        loading: false, 
        groupDetails: {}, 
        error: action.error 
      };

    // Add
    case ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_LOAD:
      return { 
        ...state, 
        loading: true, 
        adminGroup: {},         
        error: null 
      };
    case ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        adminGroup: action.adminGroup,         
        error: null 
      };
    case ADMIN_GROUP_ADD_DATA.ADMIN_GROUP_ADD_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        adminGroup: {}, 
        updateSuccess: false,
        error: action.error 
      };

    // Update
    case ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_LOAD:
      return { 
        ...state, 
        loading: true, 
        updateSuccess: false,
        error: null 
      };
    case ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        adminGroup: action.adminGroup, 
        updateSuccess: true,
        error: null 
      };
    case ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_FAIL:
      return { 
        ...state, 
        loading: false, 
        error: action.error 
      };
    case ADMIN_GROUP_UPDATE_DATA.ADMIN_GROUP_UPDATE_DATA_RESET:
      return { 
        ...state, 
        loading: false, 
        adminGroup: {}, 
        updateSuccess: false,
        error: null 
      };

    // Delete
    case ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_LOAD:
      return { 
        ...state, 
        loading: true, 
        adminGroup: {}, 
        error: null 
      };
    case ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_SUCCESS:
      return { 
        ...state, 
        loading: false, 
        adminGroup: action.adminGroup, 
        error: null 
      };
    case ADMIN_GROUP_DELETE_DATA.ADMIN_GROUP_DELETE_FAIL:
      return { 
        ...state, 
        loading: false, 
        adminGroup: {}, 
        error: action.error
      };    

    //Get admin
      case ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_LOAD:
        return {
          ...state,
          loading: true,
          error: null,
        };

      case ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_SUCCESS:
        return {
          ...state,
          loading: false,
          adminGroupAll: action.adminGroupAll,
          error: null,
        };

      case ADMIN_GROUP_GET_DATA.ADMIN_GROUP_GET_DATA_FAIL:
        return {
          ...state,
          loading: false,
          error: action.error,
        };

    // Update Admin Flag
    case ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_LOAD:
      return {
        ...state,
        loading: true,
        updateFlagSuccess: false,
        error: null,
      };
    case ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_SUCCESS:
      return {
        ...state,
        loading: false,
        updateFlagSuccess: true,
        error: null,
        // Update the specific group in the adminGroups array
        adminGroups: state.adminGroups.map((group) =>
          group.group_id === action.data.group_id
            ? { ...group, is_reporting: action.data.is_reporting, is_ticketing: action.data.is_ticketing }
            : group
        ),
      };
    case ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_FAIL:
      return {
        ...state,
        loading: false,
        updateFlagSuccess: false,
        error: action.error,
      };
    case ADMIN_GROUP_UPDATE_FLAG_DATA.ADMIN_GROUP_UPDATE_FLAG_RESET:
      return {
        ...state,
        loading: false,
        updateFlagSuccess: false,
        error: null,
      };

    default:
      return { ...state };
  }
};

export default Reducer;